import { MenuItem } from "./MenuItem";

export const MenuItems: MenuItem[] = [
    {
        hasIcon: true,
        icon: "dashboard",
        text: "Dashboard",
        hasLink: true,
        link: "/dashboard",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "business",
        text: "Organizations",
        hasLink: true,
        link: "/organizations",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "home",
        text: "Properties",
        hasLink: true,
        link: "/properties",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "people",
        text: "Guests",
        hasLink: true,
        link: "/guests",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "assessment",
        text: "Screening Report",
        hasLink: true,
        link: "/screening-report",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "event_note",
        text: "Reservations",
        hasLink: true,
        link: "/reservations",
        disabled: false,
        expanded: false
    },
    {
        hasIcon: true,
        icon: "folder",
        text: "Claims",
        hasLink: true,
        link: "/claims"
    },
    {
        hasIcon: true,
        icon: "verified_user",
        text: "Insurance Policies",
        hasLink: true,
        link: "/policies"
    },
    {
        hasIcon: true,
        icon: "monetization_on",
        text: "Price Rates",
        hasLink: true,
        link: "/price-rates"
    },
    {
        hasIcon: true,
        // icon: "new_releases",
        // icon: "queue",
        // icon: "info_outline",
        // icon: "feedback",
        icon: "assignment_late",
        text: "Verification Packages",
        hasLink: true,
        link: "/verification-packages"
    },
    {
        hasIcon: true,
        icon: "build",
        text: "Operations",
        hasLink: true,
        link: "/operations"
    },
    {
        hasIcon: true,
        icon: "account_balance",
        text: "Underwriters",
        hasLink: true,
        link: "/underwriters"
    },
    {
        hasIcon: true,
        icon: "not_interested",
        text: "Bad Guests",
        hasLink: true,
        link: "/bad-guests"
    },
    {
        hasIcon: true,
        icon: "person_outline",
        text: "Referrals",
        hasLink: true,
        link: "/referrals"
    },
    {
        hasIcon: true,
        icon: "lock",
        text: "Permissions",
        hasLink: true,
        link: "/permissions"
    },
    {
        hasIcon: true,
        icon: "history",
        text: "Audit Trail",
        hasLink: true,
        link: "/audit-trail"
    }
]